type LoadState = 'idle' | 'loading' | 'loaded' | 'error' | 'external_load';

let loadState: LoadState = 'idle';

export const getLoadState = () => loadState;
export const setLoadState = (state: LoadState) => {
    loadState = state;
};
